// Libs
import { TFunction } from 'i18next';
import moment from 'moment';

export default (t: TFunction, startDate: string, endDate: string): string => {
  const start = moment(startDate);
  const end = moment(endDate);
  const dateFormat = 'DD MMM YYYY';
  const isFullTerm =
    start.format('MM-DD') === '07-01' && end.format('MM-DD') === '06-30';

  return isFullTerm
    ? `${t('district-officers.term', 'Term')}: ${start.year()}-${end.year()}`
    : `${t('district-officers.term.start', 'Start')}: ${start.format(
        dateFormat
      )} ${t('district-officers.term.end', 'End')}: ${end.format(dateFormat)}`;
};
